<template>
  <div>
    <div v-for="(notes, key) in this.notes" :key="key" class="my-1">
      <div>
        <!-- {{ key }} -->
        <span class="mr-1 overline">{{ keyTitle(key) }}</span>

        <v-dialog max-width="500" v-if="keyDefinitions[key]">
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon small v-bind="attrs" v-on="on">
              <v-icon small color="primary">mdi-information-outline</v-icon>
            </v-btn>
          </template>

          <v-card>
            <v-card-title>{{ keyTitle(key) }}</v-card-title>
            <v-card-text class="mt-2">
              {{ keyDefinitions[key] }}
            </v-card-text>

            <v-divider></v-divider>
          </v-card>
        </v-dialog>
      </div>
      <ul>
        <li v-for="(note, i) in notes" :key="i" v-html="addIcdLinks(note)"></li>
      </ul>
    </div>
    <div class="ml-6 d-flex flex-row flex-wrap">
      <div v-for="(item, key) in sevenChar" :key="key" class="mr-4">
        <b>{{ key }}</b
        >: {{ item }}
      </div>
    </div>
  </div>
</template>

<script>
import FormatIcdMixin from "@/assets/js/icd/FormatIcdMixin";

export default {
  name: "NotesFormatter.vue",
  mixins: [FormatIcdMixin],
  props: {
    notes: null,
    sevenChar: null,
  },
  data: function () {
    return {
      dialog: [false, false, false],
      keyDefinitions: {
        excludes2:
          "An excludes2 note represents 'Not included here'.  This indicates that the condition excluded is not part of the condition it is excluded from but a patient may have both conditions at the same time.  When an Excludes2 note appears under a code it is acceptable to use both the code and the excluded code together.",
        excludes1:
          "AnExcludes1 note is a pure excludes.  It means 'NOT CODED HERE!'  An Excludes1 note indicates that the code excluded should never be used at the same time as the code above the Excludes1 note.  An Excludes1 is used when two conditions cannot occur together, such as a congenital form versus an acquired form of the same condition.",
        includes:
          "The word 'Includes' further defines, or give examples of, the content of the category.",
      },
    };
  },
  methods: {
    keyTitle(str) {
      let rtn = str.toUpperCase();
      if (rtn == "INCLUDES") rtn = "Includes";
      if (rtn == "EXCLUDES2") rtn = "Excludes(2)";
      if (rtn == "EXCLUDES1") rtn = "Excludes(1)";
      if (rtn == "USEADDITIONALCODE") rtn = "Use Additional Code";
      return rtn;
    },
  },
  computed: {},
};
</script>

<style scoped></style>
